const rootFontSize = 16;
const buttonBorderRadius = 1000;

export { buttonBorderRadius, rootFontSize };
